export const calculateBMI = (weightKg, feet, inches) => {
  if (!weightKg || !feet) return null;
  const totalInches = Number(feet) * 12 + Number(inches || 0);
  const heightInMeters = totalInches * 0.0254;
  const heightSquared = heightInMeters * heightInMeters;
  const bmi = Number(weightKg) / heightSquared;
  return parseFloat(bmi.toFixed(1));
};

export const getBMICategory = (bmi) => {
  const b = parseFloat(bmi);
  if (!b || isNaN(b)) return { label: "—", color: "#999", range: "" };
  if (b < 18.5)
    return { label: "Underweight", color: "#3b82f6", range: "< 18.5" };
  if (b < 25)
    return { label: "Normal", color: "#22c55e", range: "18.5 – 24.9" };
  if (b < 30)
    return { label: "Overweight", color: "#f59e0b", range: "25 – 29.9" };
  return { label: "Obese", color: "#ef4444", range: "≥ 30" };
};

export const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

export const formatTime = (date) =>
  new Date(date).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  });

export const todayISO = () => new Date().toISOString().split("T")[0];

// "6h 42m" / "45m" — used by WeeklySnapshot + workout post stats.
export const formatDuration = (minutes) => {
  const m = Math.round(minutes || 0);
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (h === 0) return `${rem}m`;
  return rem === 0 ? `${h}h` : `${h}h ${rem}m`;
};

// "38,450" — locale-aware thousands separator.
export const formatNumber = (n) => Math.round(n || 0).toLocaleString("en-IN");

// "Today • 7:42 PM" / "Yesterday • 6:10 AM" / "3d ago" — post header timestamps.
export const formatRelativeTime = (isoDate) => {
  const date = new Date(isoDate);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60_000);

  if (diffMins < 1) return "Just now";
  if (diffMins < 60) return `${diffMins}m ago`;

  const isToday = date.toDateString() === now.toDateString();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday = date.toDateString() === yesterday.toDateString();

  const time = formatTime(date);
  if (isToday) return `Today • ${time}`;
  if (isYesterday) return `Yesterday • ${time}`;

  const diffDays = Math.floor(diffMins / 1440);
  if (diffDays < 7) return `${diffDays}d ago`;
  return formatDate(date);
};
